import type { HttpHeader } from '@reqshare/protocol';
import { isSensitiveHeader } from '@reqshare/shared';
import { SensitiveValue } from '../SensitiveValue/SensitiveValue';
import './HeadersBlock.scss';

interface HeadersBlockProps {
  title: string;
  headers: HttpHeader[];
}

export function HeadersBlock({ title, headers }: HeadersBlockProps) {
  if (headers.length === 0) {
    return null;
  }

  return (
    <section className="headers-block">
      <h3 className="headers-block__title">{title}</h3>
      <div className="headers-block__table-wrapper">
        <table className="headers-block__table">
          <thead>
            <tr>
              <th className="headers-block__th">Name</th>
              <th className="headers-block__th">Value</th>
            </tr>
          </thead>
          <tbody>
            {headers.map((header, index) => (
              <tr className="headers-block__row" key={`${header.name}-${index}`}>
                <td className="headers-block__name">{header.name}</td>
                <td className="headers-block__value">
                  {isSensitiveHeader(header.name) ? (
                    <SensitiveValue name={header.name} value={header.value} />
                  ) : (
                    <span className="headers-block__value-text">{header.value}</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
